module.exports = __webpack_public_path__ + "img/India.c8f8217d.png";